<script>
import ItemComponent from './Item/component.vue';
import BuyerComponent from './Buyer/component.vue';
import TypeComponent from './TypeComponent.vue';
import PayerComponent from './PayerComponent.vue';

export default {
  components: {
    ItemComponent,
    BuyerComponent,
    TypeComponent,
    PayerComponent,
  },
  props: {
    module: Object,
    isWidget: {
      type: Boolean,
      default: false,
    },
    isAuth: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<template>
  <div
    v-if="module"
    class="p-t-c-it"
  >
    <div class="p-t-c-it__label">Туристы</div>
    <RowSpan>
      <ColGroup
        v-for="(item, idx) in module.items"
        :key="idx"
        :label="item.age.value | label"
      >
        <ItemComponent
          class="p-t-c-it__item"
          :module="item"
        />
      </ColGroup>
    </RowSpan>
      <div class="p-t-c-it__label">Покупатель</div>
     <BuyerComponent :module="module.buyer"/>
  </div>
</template>
<style lang="scss">
  .p-t-c-it {
    &__item {
      margin: 0 8px;
    }

    &__label {
      margin-bottom: 8px;
      font-weight: 700;
    }
  }
  @media (max-width: 800px) {
    .p-t-c-it {
      .col-span--3 {
        width: 50%;
      }

      .col-span--6 {
        width: 100%;
      }
    }
  }
  @media (max-width: 500px) {
    .p-t-c-it {
      .col-span--3 {
        width: 100%;
      }

      .col-span--6 {
        width: 100%;
      }
    }
  }
</style>
